let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g0vXa")).then(() => parcelRequire('emtky'));